import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtDate } from "./shared";

const TIME_LABEL = { tilgjengelig: "Utløper", aktiv: "Aktivert", innlost: "Innløst", utgatt: "Utløp / aktivert" };

function timeFor(status, i) {
  if (status === "innlost") return i.innlost;
  if (status === "aktiv") return i.aktivert;
  return i.aktivert || i.utloper;
}

export function CouponListDialog({ status, label, onClose }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!status) return;
    setItems(null);
    api
      .get("/admin/coupon-list", { params: { status } })
      .then((res) => setItems(res.data.items))
      .catch((err) => toast.error(formatApiErrorDetail(err.response?.data?.detail)));
  }, [status]);

  return (
    <Dialog open={!!status} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-3xl overflow-hidden border-white/10 bg-[#282421] text-[#FDFBF7]" data-testid="coupon-list-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl">{label}</DialogTitle>
          <DialogDescription className="text-[#A8A29E]" data-testid="coupon-list-count">
            {items ? `${items.length} kuponger` : "Laster…"}
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-auto">
          {items && items.length === 0 && <p className="text-sm text-[#A8A29E]" data-testid="coupon-list-empty">Ingen kuponger her.</p>}
          {items && items.length > 0 && (
            <table className="w-full min-w-[560px] text-left text-sm">
              <thead>
                <tr className="text-xs uppercase tracking-wide text-[#A8A29E]">
                  <th className="pb-2 pr-4">Gjest</th>
                  <th className="pb-2 pr-4">Kontakt</th>
                  <th className="pb-2 pr-4">Kupong</th>
                  <th className="pb-2">{TIME_LABEL[status]}</th>
                </tr>
              </thead>
              <tbody>
                {items.map((i) => (
                  <tr key={`${i.type}-${i.id}`} className="border-t border-white/5" data-testid={`coupon-list-row-${i.id}`}>
                    <td className="py-2.5 pr-4 font-medium">{i.fornavn || "—"}</td>
                    <td className="py-2.5 pr-4 text-[#A8A29E]">
                      <div>{i.epost || "—"}</div>
                      <div className="text-xs">{i.telefon}</div>
                    </td>
                    <td className="py-2.5 pr-4">
                      <span className={`mr-2 rounded-full px-2 py-0.5 text-[0.65rem] uppercase ${i.type === "velkomst" ? "bg-[#D4AF37]/15 text-[#E5C564]" : "bg-white/10 text-[#FDFBF7]"}`}>
                        {i.type === "velkomst" ? "Velkomst" : "Kampanje"}
                      </span>
                      <span className="text-[#A8A29E]">{i.type === "kampanje" ? i.tittel : ""}</span>
                    </td>
                    <td className="py-2.5 text-[#E5C564]">{fmtDate(timeFor(status, i))}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
